module.exports = __webpack_public_path__ + "media/images/Reboot-icon-display-a6c8e8769b22d4b43b4ac23aefdeb4c3.svg";